var chunkToChildrenMap = {
	"535": [
		1185
	],
	"752": [
		8849,
		7343,
		2919,
		1716,
		4261,
		5894,
		2874,
		7922,
		9335,
		5839
	],
	"7552": [
		8849,
		7343,
		2919,
		1716,
		4261,
		5894,
		2874,
		7922,
		9335,
		5839
	],
	"8117": [
		8849,
		7343,
		9175,
		4219,
		6834
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));